import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import {
  pickServiceGroupId,
  pickServiceGroupName,
  SubscriptionDetail,
} from '@/types/subscriptions/subscription';
import { SERVICE_GROUP_ID } from '@/constants';
import { isNewAndEditAndCancelOfHodaiPlusEnded } from '@/utils/date';

import { CancelOrder } from './CancelOrder';
import { EditBtn } from './EditBtn';

type Props = {
  subscription: SubscriptionDetail;
  cancelSubscription: (id: number) => void;
};

export const DetailHeader: React.FC<Props> = ({
  subscription,
  cancelSubscription,
}) => {
  const { t } = useTranslation();

  const id = pickServiceGroupId(subscription);
  const shouldHideEditAndCancelButtons =
    id === SERVICE_GROUP_ID.hodaiplus &&
    isNewAndEditAndCancelOfHodaiPlusEnded();

  return (
    <Styled>
      <div>
        <div className="control">
          {!shouldHideEditAndCancelButtons && (
            <>
              <CancelOrder
                subscription={subscription}
                cancelSubscription={cancelSubscription}
              />
              <EditBtn subscription={subscription} />
            </>
          )}
        </div>
        <div className="info">
          <span className="service-group-name">{`${pickServiceGroupName(
            subscription,
          )}`}</span>
          <span className="request-code">{`${t(
            'models.subscription.requestCode',
          )}: ${
            subscription.requestCode ? subscription.requestCode : ''
          }`}</span>
        </div>
      </div>
    </Styled>
  );
};

const Styled = styled.div`
  .control {
    display: flex;
    justify-content: flex-end;
    margin-top: 1.5em;
    gap: 3.5px;
    padding-right: 3.5px;
  }
  .info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 2em 0 1.5em;
  }

  .service-group-name {
    font-weight: bold;
  }

  .request-code {
    margin-left: 6em;
  }
`;
